import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/services/loading.service';
import { TenantSubscriptionService } from 'src/app/services/tenants/tenant-subscription.service';

@Component({
  selector: 'app-deactivate-publishing-mode-modal',
  standalone: false,
  templateUrl: './deactivate-publishing-mode-modal.component.html',
  styleUrl: './deactivate-publishing-mode-modal.component.scss'
})
export class DeactivatePublishingModeModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  
  @Input() hasSubscription = true;
  
  @Input() publishToSubscribers = false;
  @Output() publishToSubscribersChange = new EventEmitter<boolean>();
  
  @Output() onCancel = new EventEmitter();
  @Output() onDeactivate = new EventEmitter();
  
  constructor(
    private toastrService: ToastrService,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private tenantSubscriptionService: TenantSubscriptionService
  ) {
   
  }

  deactivate() {
    if(this.hasSubscription) {
      this.loadingService
        .load(
          this.tenantSubscriptionService.deactivatePublishingMode()
        )
        .subscribe(() => {
          this.toastrService.success(
            this.translateService.instant(
              'PUBLISHING-MODE.DEACTIVATE-PUBLISHING-MODE.DEACTIVATED-PUBLISHING-MODE-SUCCESSFULLY'
            )
          );
          this.publishToSubscribers = false;
          this.publishToSubscribersChange.emit(this.publishToSubscribers);

          this.onDeactivate.emit();
          this.close();
        });
    } else {
      this.publishToSubscribers = false;
      this.publishToSubscribersChange.emit(this.publishToSubscribers);

      this.onDeactivate.emit();
      this.close();
    }
  }

  cancel() {
    this.onCancel.emit();
    this.close();
  }

  private close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
